<template>
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 22 24"
    style="enable-background:new 0 0 22 24;"
    xml:space="preserve"
    :style="{height: iconHeight}"
  >
    <g
      id="KMZ_Icon"
      transform="translate(-6176 4201)"
    >
      <g
        id="Path_1637"
        transform="translate(6178 -4201)"
      >
        <path
          class="st0"
          d="M2,0h11.6L20,6.5l-0.1,15.6c0,1.1-0.9,1.9-2,1.9H2c-1.1,0-2-0.8-2-1.9V1.9C0,0.8,0.9,0,2,0z"
        />
        <path
          class="st1"
          d="M2.5,2.5v19h14.9l0.1-14l-4.9-5H2.5 M2,0h11.6L20,6.5l-0.1,15.6c0,1.1-0.9,1.9-2,1.9H2c-1.1,0-2-0.9-2-1.9V1.9C0,0.9,0.9,0,2,0z"
        />
      </g>
      <path
        id="Path_1638"
        class="st1"
        d="M6190.5-4199l5.4,6h-5.4V-4199z"
      />
      <path
        id="Rectangle_848"
        class="st1"
        d="M6178-4191.6h18l0,0v10l0,0h-18c-1.1,0-2-0.9-2-2v-6C6176-4190.7,6176.9-4191.6,6178-4191.6z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'KMZIcon',
  props: {
    iconHeight: {
      type: String,
      default: '38px',
    },
  },
};
</script>

<style lang="scss" scoped>
.st0{fill:none;}
.st1{fill: main.$npGray;}
</style>

